import HttpRequests from '../../classes/http/HttpRequests';
import AuthSerivce from '../auth.service';
import ServerApis from './ServerApis';
var ApiRequests = /** @class */ (function () {
    function ApiRequests() {
        var _this = this;
        this.http = new HttpRequests();
        this.login = function (credentials) {
            return _this.http.post(ServerApis.loginApi, credentials
            // {headers: {'Content-Type': `multipart/form-data`}}
            );
        };
        this.twoFAToken = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.twoFAToken, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.twoFATokenPost = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.twoFAToken, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.logout = function (token) {
            return _this.http.post(ServerApis.logoutApi, {}, { headers: { 'X-Auth-Token': token } });
        };
        // DeliveryMethods methods
        this.getDeliveryMethods = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getDeliveryMethods, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // PromoCodes
        this.getPromoCodes = function (pageNumber) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPromoCodes(pageNumber), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getPromoCodeTypes = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPromoCodeTypes, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getPromoCode = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPromoCode(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updatePromoCode = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updatePromoCode(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createPromoCode = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createPromoCode, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getDeliveryMethod = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getDeliveryMethod(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getDeliveryTypes = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getDeliveryTypes, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getFreeShipping = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getFreeShipping, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createDeliveryMethod = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createDeliveryMethod, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateDeliveryMethod = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateDeliveryMethod(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateFreeShipping = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateFreeShipping(), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // SpecialOffers methods
        this.getSpecialOffers = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSpecialOffers, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getSpecialOffer = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSpecialOffer(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createSpecialOffer = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createSpecialOffer, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateSpecialOffer = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateSpecialOffer(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteSpecialOffer = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteSpecialOffer(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // SpecialOffers methods
        this.getRelatedCollections = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getRelatedCollections(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getRelatedCollection = function (productId, id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getRelatedCollection(productId, id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createRelatedCollection = function (productId, data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createRelatedCollection(productId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteRelatedCollection = function (productId, id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteRelatedCollection(productId, id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Suggestion offers methods
        this.getSuggestionOffers = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSuggestionOffers, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getSuggestionOffer = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSuggestionOffer(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createSuggestionOffer = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createSuggestionOffer, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateSuggestionOffer = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateSuggestionOffer(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteSuggestionOffer = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteSuggestionOffer(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteSearch = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteSearch(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deletePromoCode = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deletePromoCode(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Adjustment Levels
        this.getAdjustmentLevels = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getAdjustmentLevels, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createAdjustmentLevel = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createAdjustmentLevel, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteAdjustmentLevel = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteAdjustmentLevel(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // PaymentMethods methods
        this.getPaymentMethods = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPaymentMethods, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getPaymentMethod = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPaymentMethod(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createPaymentMethod = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createPaymentMethod, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updatePaymentMethod = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updatePaymentMethod(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Brands
        this.getBrands = function (pageNumber) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getBrands(pageNumber), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchBrands = function (searchString) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchBrands(searchString), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchBrandsPost = function (searchString) {
            var token = AuthSerivce.getToken();
            var url = ServerApis.searchBrandsPost(searchString);
            return _this.http.post(url, {}, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchGifts = function (searchString) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchGifts(searchString), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getBrand = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getBrand(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createBrand = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createBrand, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateBrand = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateBrand(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        // Samples
        this.getSamples = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSamples(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getGifts = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getGifts, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getSample = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSample(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getGift = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getGift(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createSample = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createSample, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.createGift = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createGift, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateSample = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateSample(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateGift = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateGift(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteSample = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteSample(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteGift = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteGift(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getSamplesStatuses = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSamplesStatuses, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getGiftsStatuses = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getGiftsStatuses, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getDisplayOptions = function (brand_id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getDisplayOptions(brand_id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getVariantQuantity = function (product_id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVariantQuantity(product_id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Main Static pages
        this.getMainStaticPages = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getMainStaticPages, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getMainStaticPage = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getMainStaticPage(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createMainStaticPage = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createMainStaticPage, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateMainStaticPage = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateMainStaticPage(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteMainStaticPage = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteMainStaticPage(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getMainStaticPageTypes = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getMainStaticPageTypes, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Brands Slides
        this.getBrandSlides = function (brandId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getBrandSlides(brandId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getBrandSlide = function (brandId, slideId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getBrandSlide(brandId, slideId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createBrandSlide = function (data, brandId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createBrandSlide(brandId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateBrandSlide = function (data, brandId, slideId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateBrandSlide(brandId, slideId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteBrandSlide = function (slideId, brandId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteBrandSlide(brandId, slideId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Brands Product lines
        this.getProductLines = function (brandId, staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getProductLines(brandId, staticPageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createProductLine = function (data, brandId, staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createProductLine(brandId, staticPageId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getProductLine = function (productLineId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getProductLine(productLineId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateProductLine = function (data, productLineId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateProductLine(productLineId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteProductLine = function (productLineId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteProductLine(productLineId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Static page Product line
        this.getStaticProductLines = function (staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getStaticProductLines(staticPageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createStaticProductLine = function (data, staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createStaticProductLine(staticPageId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getStaticProductLine = function (staticPageId, productLineId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getStaticProductLine(staticPageId, productLineId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateStaticProductLine = function (data, staticPageId, productLineId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateStaticProductLine(staticPageId, productLineId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteStaticProductLine = function (staticPageId, productLineId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteStaticProductLine(staticPageId, productLineId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Rituals
        this.getRituals = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getRituals, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createRitual = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createRitual, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getRitual = function (ritualId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getRitual(ritualId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateRitual = function (data, ritualId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateRitual(ritualId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateCategoryProduct = function (data, catId, prodId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateCategoryProduct(catId, prodId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteRitual = function (ritualId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteRitual(ritualId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Static pages
        this.getStaticPages = function (brandId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getStaticPages(brandId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getStaticPage = function (brandId, staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getStaticPage(brandId, staticPageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createStaticPage = function (data, brandId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createStaticPage(brandId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateStaticPage = function (data, brandId, staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateStaticPage(brandId, staticPageId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteStaticPage = function (brandId, staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteStaticPage(brandId, staticPageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Option types
        this.getOptionTypes = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getOptionTypes, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getDisplayTypes = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getDisplayTypes, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getOptionType = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getOptionType(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createOptionType = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createOptionType, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateOptionType = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateOptionType(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Option Values
        this.getOptionValues = function (optionTypeId, pageNumber) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getOptionValues(optionTypeId, pageNumber), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getOptionValue = function (optionTypeId, optionValueId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getOptionValue(optionTypeId, optionValueId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchOptionValues = function (optionTypeId, term) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchOptionValues(optionTypeId, term), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createOptionValue = function (data, optionTypeId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createOptionValue(optionTypeId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateOptionValue = function (data, optionTypeId, optionValueId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateOptionValue(optionTypeId, optionValueId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Regions
        this.getRegions = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getRegions, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getRegion = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getRegion(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createRegion = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createRegion, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateRegion = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateRegion(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteRegion = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteRegion(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Prices
        this.getPrices = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPrices, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getPrice = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPrice(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createPrice = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createPrice, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updatePrice = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updatePrice(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deletePrice = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deletePrice(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Users
        this.getUsers = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getUsers(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteUser = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteUser(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getProblemOrders = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getProblemOrders(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getOrders = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getOrders(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getOrder = function (num) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getOrder(num), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.refreshOrderStatus = function (num) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.refreshOrderStatus(num), {}, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.resenderErpStatus = function (num) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.resenderErpStatus(num), {}, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchOrders = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchOrders(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchProblemOrders = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchProblemOrders(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.assignOrderToOperator = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.assignOperatorToOrder(id), {}, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Categories
        this.getCategories = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getCategories, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchCategories = function (searchString) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchCategories(searchString), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchBarcode = function (searchString) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchBarcode(searchString), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchOneResult = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchOneResult(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getCategory = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getCategory(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getBrandCategory = function (brand_id, id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getBrandCategory(brand_id, id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createCategory = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createCategory, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateCategory = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateCategory(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteCategory = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteCategory(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.hideCategory = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.hideCategory(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Brands Slides
        this.getCategorySlides = function (categoryId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getCategorySlides(categoryId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Static page Slides
        this.getStaticPageSlides = function (brandId, staticPageId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getStaticPageSlides(brandId, staticPageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Create Static Page Slide
        this.createStaticPageSlide = function (brandId, staticPageId, data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.getStaticPageSlides(brandId, staticPageId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        // Get Static page Slide
        this.getStaticPageSlide = function (brandId, staticPageId, slideId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getStaticPageSlide(brandId, staticPageId, slideId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Update Static page Slide
        this.updateStaticPageSlide = function (brandId, staticPageId, slideId, data) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.getStaticPageSlide(brandId, staticPageId, slideId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        // Update Static page Slide
        this.deleteStaticPageSlide = function (brandId, staticPageId, slideId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.getStaticPageSlide(brandId, staticPageId, slideId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getCategorySlide = function (categoryId, slideId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getCategorySlide(categoryId, slideId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createCategorySlide = function (data, categoryId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createCategorySlide(categoryId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateCategorySlide = function (data, categoryid, slideId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateCategorySlide(categoryid, slideId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteCategorySlide = function (slideId, categoryId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteCategorySlide(categoryId, slideId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createBrandCategory = function (id, data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createBrandCategory(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateBrandCategory = function (brand_id, id, data) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateBrandCategory(brand_id, id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getBrandCategories = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getBrandCategories(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchCategory = function (text) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchCategory(text), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchBrandCategory = function (text) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchBrandCategory(text), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Slides
        this.getSlides = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSlides(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getSlide = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSlide(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createSlide = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createSlide, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateSlide = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateSlide(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteSlide = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteSlide(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getPromoSlides = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPromoSlides(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getPromoSlide = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getPromoSlide(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createPromoSlide = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createPromoSlide, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updatePromoSlide = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updatePromoSlide(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deletePromoSlide = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deletePromoSlide(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteBrandCategory = function (brand_id, id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteBrandCategory(brand_id, id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Static images
        this.getStaticImages = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getStaticImages(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createStaticImage = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createStaticImage, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteStaticImage = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteStaticImage(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchStaticImages = function (searchString) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchStaticImages(searchString), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Search
        this.getSearches = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSearches(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // seo text in home page
        this.getSeoTextHome = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSeoTextHome(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createSeoText = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createSeoText, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        //   public postSearches = (data: object): Promise<any> => {
        //     const token = AuthSerivce.getToken();
        //     return this.http.post(ServerApis.postSearches, data, {
        //         headers: {
        //             'X-Auth-Token': token,
        //             'Content-Type': 'application/json',
        //         },
        //     });
        // };
        // Homepage Template
        this.getTemplates = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getTemplates(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getTypeTemplate = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getTypeTemplate(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createTemplate = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createTemplate, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data;',
                },
            });
        };
        this.templateOneResult = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.templateOneResult(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateTemplate = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateTemplate(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data;',
                },
            });
        };
        this.deleteTemplate = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteTemplate(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Products
        this.getProducts = function (pageNumber) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getProducts(pageNumber), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getCategoryProducts = function (id, page) {
            if (page === void 0) { page = 1; }
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getCategoryProducts(id, page), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getProduct = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getProduct(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createProduct = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createProduct, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createSearch = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createSearch, data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateProduct = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateProduct(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateSearch = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateSearch(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getProductsStatuses = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getProductsStatuses, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        //     public getSearchStatuses = (): Promise<any> => {
        //     const token = AuthSerivce.getToken();
        //     return this.http.get(ServerApis.getSearchStatuses, {
        //         headers: {
        //             'X-Auth-Token': token,
        //             'Content-Type': 'application/json',
        //         },
        //     });
        // };
        this.getSearchStatuses = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getSearchStatuses(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchProducts = function (searchString) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchProducts(searchString), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchPromoCodes = function (searchString) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchPromoCodes(searchString), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.searchProductsCategory = function (searchString, category_id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.searchProductsCategory(searchString, category_id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Reviews
        this.getReviews = function (productId, page) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getReviews(productId, page), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getUnapprovedReviews = function (page) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getUnapprovedReviews(page), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getReview = function (reviewId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getReview(reviewId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteReview = function (reviewId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteReview(reviewId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateReview = function (data, reviewId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateReview(reviewId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Variants
        this.getVariants = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVariants(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getVariant = function (productId, variantId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVariant(productId, variantId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createVariant = function (data, productId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createVariant(productId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateVariant = function (data, productId, variantId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateVariant(productId, variantId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getVariantStatuses = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVariantStatuses(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Color Images
        this.getColorImage = function (productId, variantId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getColorImage(productId, variantId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createColorImage = function (data, productId, variantId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createColorImage(productId, variantId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateColorImage = function (data, productId, variantId, colorImageId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateColorImage(productId, variantId, colorImageId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteColorImage = function (productId, variantId, colorImageId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteColorImage(productId, variantId, colorImageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // additional_images
        this.getAdditionalImage = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getAdditionalImage(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createAdditionalImage = function (data, productId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createAdditionalImage(productId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateAdditionalImage = function (data, productId, colorImageId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateAdditionalImage(productId, colorImageId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteAdditionalImage = function (productId, colorImageId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteAdditionalImage(productId, colorImageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Variant images
        this.getVariantImages = function (productId, variantId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVariantImages(productId, variantId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getVariantImage = function (productId, variantId, variantImageId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVariantImage(productId, variantId, variantImageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createVariantImage = function (data, productId, variantId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createVariantImage(productId, variantId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateVariantImage = function (data, productId, variantId, variantImageId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateVariantImage(productId, variantId, variantImageId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.deleteVariantImage = function (productId, variantId, variantImageId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteVariantImage(productId, variantId, variantImageId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // refreshButton
        this.getRefreshButtonStatus = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.refreshButtonStatus(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.resenderRefreshButton = function () {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.resenderRefreshButton(), [], {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getVolumePromotions = function (params) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVolumePromotions(params), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteVolumePromotion = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.getVolumePromotion(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getVolumePromotion = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getVolumePromotion(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createVolumePromotion = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createVolumePromotion(), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.updateVolumePromotion = function (data, id) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.getVolumePromotion(id), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getVolumeImportsStatus = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.volumePromotionImport(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.sendVolumeImportFile = function (data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.volumePromotionImport(), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.getLevelsForVolumePromotion = function (id) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getLevelsForVolumePromotion(id), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getLevelForVolumePromotion = function (id, levelId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getLevelForVolumePromotion(id, levelId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createLevelForVolumePromotion = function (volumeId, data) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.getLevelsForVolumePromotion(volumeId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateLevelFromVolumePromotion = function (volumeId, levelId, data) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.getLevelForVolumePromotion(volumeId, levelId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteLevelFromVolumePromotion = function (volumeId, levelId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.getLevelForVolumePromotion(volumeId, levelId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        // Filter Options
        this.getFilterOptions = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getFilterOptions(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.postPromocodeFile = function (formData) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.uploadPromocodeFile(), formData, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'multipart/form-data',
                },
            });
        };
        this.getFilterOption = function (productId, filterOptionId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getFilterOption(productId, filterOptionId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteFilterOption = function (productId, filterOptionId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteFilterOption(productId, filterOptionId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createFilterOption = function (data, filterOptionsId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createFilterOption(filterOptionsId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.updateFilterOption = function (data, productId, filterOptionsId) {
            var token = AuthSerivce.getToken();
            return _this.http.put(ServerApis.updateFilterOption(productId, filterOptionsId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getFilterTypes = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getFilterTypes(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.generateBol = function (orderNum) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.generateBol(orderNum), null, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getProductLabels = function () {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getProductLabels(), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getAromaticNotes = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getAromaticNotes(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getAromaticNote = function (productId, aromaticNoteId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getAromaticNote(productId, aromaticNoteId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.createAromaticNote = function (data, productId) {
            var token = AuthSerivce.getToken();
            return _this.http.post(ServerApis.createAromaticNote(productId), data, {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.deleteAromaticNote = function (productId, aromaticNoteId) {
            var token = AuthSerivce.getToken();
            return _this.http.delete(ServerApis.deleteAromaticNote(productId, aromaticNoteId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
        this.getAromaticNoteTypes = function (productId) {
            var token = AuthSerivce.getToken();
            return _this.http.get(ServerApis.getAromaticNoteTypes(productId), {
                headers: {
                    'X-Auth-Token': token,
                    'Content-Type': 'application/json',
                },
            });
        };
    }
    return ApiRequests;
}());
export default ApiRequests;



//////////////////
// WEBPACK FOOTER
// ./src/classes/http/ApiRequests.ts
// module id = 3
// module chunks = 0